module.exports = __webpack_public_path__ + "static/media/icon-social.638890ea.svg";